<template>
  <v-menu
    ref="dateRangeMenu"
    v-model="dateRangeMenu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dates"
        required
        filled
        rounded
        class="rounded-small"
        label="Rango de fecha"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      locale="es-us"
      v-model="dates"
      :max="new Date().toISOString().substr(0, 10)"
      range
      scrollable
      no-title
    >
      <v-spacer></v-spacer>
      <v-hover v-slot:default="{ hover }">
        <v-btn
          text
          rounded
          class="mr-1"
          :color="hover ? 'error' : 'grey'"
          @click="dateRangeMenu = false"
        >
          Cancelar
        </v-btn>
      </v-hover>

      <v-hover v-slot:default="{ hover }">
        <v-btn
          rounded
          color="success"
          :class="hover ? 'shadow-2' : 'shadow-4'"
          class="px-8"
          @click="$refs.dateRangeMenu.save(dates)"
        >
          ok
        </v-btn>
      </v-hover>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      dateRangeMenu: false,
      dates: [],
    };
  },

  watch: {
    dates() {
      this.$emit("dates:change", this.dates);
    },
  },
};
</script>

<style></style>
